module.exports = __webpack_public_path__ + "6d818c17055764de64dad4e181174493.svg";